import { HiOutlineHashtag } from "react-icons/all";
import {BsMusicNoteBeamed} from "react-icons/all";
import {BiSearch} from "react-icons/all";
import { useEffect, useState } from "react"

const Discover = () => {
  
  const [discover, setDiscover] = useState([])

  const getDiscover = () => {
    fetch("https://pastebin.com/raw/i7JqSqi0")
    .then(response => response.json())
    .then(data => setDiscover(data))
  }

  useEffect (() =>{
    getDiscover()
  }, [])
  return (
  <div id="Discover" className="d-none d-lg-block">
    <p className="title">Discover</p>
  {discover.map(d => (
    <div className="trend" key={d.id}>
      <div className="icon">
      {d.type === "tag" ? (
      <HiOutlineHashtag /> 
      ): d.type ==="song" ? (
      <BsMusicNoteBeamed/> 
      ): (
      <BiSearch/>
      )}{""} 
      </div>
      <div className="content">{d.content}</div>
      </div>
  ))}
  </div>)
}

export default Discover